import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, useDialogPaperSx } from "../../hatim/soft/SoftKit";

/** Kişisel kodu yenileme onayı (mobildeki "Kodu yenile" katmanıyla aynı metin). */
export default function RegenerateMemberCodeConfirm({ open, loading, onClose, onConfirm }) {
  const { t } = useScriptMode();
  const paperSx = useDialogPaperSx();
  return (
    <Dialog open={!!open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs" PaperProps={{ sx: paperSx }}>
      <DialogTitle sx={{ fontWeight: 500 }}>{t("Kodu yenile")}</DialogTitle>
      <DialogContent>
        <p className="text-sm text-terakkiNeutral dark:text-white/70">
          {t(
            "Yeni kod üretilir, eski kodunuz hemen geçersiz olur. Kodunuzu verdiğiniz yöneticilere yenisini iletmeniz gerekir."
          )}
        </p>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <SoftButton tone="cancel" onClick={onClose} disabled={loading}>
          {t("İptal")}
        </SoftButton>
        <SoftButton tone="primary" onClick={onConfirm} disabled={loading}>
          {loading ? t("Yenileniyor…") : t("Yeni kod al")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}
